module.exports = __webpack_public_path__ + "img/6.ea7adaf4.jpg";